// @flow
import React, { type Node } from 'react';
import cn from 'classnames';
import path from 'ramda/es/path';

import { Table, Tr, Th, Td } from 'app/common/ui-components/table';
import PlainTooltip from 'app/common/ui-next/plain-tooltip';
import type { Discipline } from 'app/dataTypes/Discipline.types';
import type { SummaryMarks } from 'app/dataTypes/SummaryMarks.types';

import type { Period } from '../usePeriods';
import styles from './TableSummaryContent.scss';


type Props = {
  className?: string,
  periods: Array<Period>,
  disciplines: Array<Discipline>,
  summaryMarks: SummaryMarks,
  loading?: boolean,
}

const TableSummaryContent = ({
  className,
  periods,
  disciplines,
  summaryMarks,
  loading,
}: Props): Node => {
  return (
    <Table className={cn(styles.root, className)}>
      <tbody>
        {disciplines.map(({ id, title }, rowIndex) => (
          <Tr
            key={id}
            className={styles.row}
          >
            <Th className={styles.th} stripPadding>
              {loading
                ? <div className={styles.loading}>&nbsp;</div>
                : <PlainTooltip text={title} className={styles.content} hideWithoutOverflow>
                  {`${rowIndex + 1}. ${title}`}
                </PlainTooltip>}
            </Th>

            {periods.map(({ title: key }, periodIndex) => (
              <Td
                key={key}
                className={styles.td}
                stripPadding
              >
                {path([id, periodIndex + 1], summaryMarks)}
              </Td>
            ))}

            <Td
              className={styles.td}
              stripPadding
            >
              {path([id, 'year'], summaryMarks)}
            </Td>
          </Tr>
        ))}
      </tbody>
    </Table>
  );
};

export default TableSummaryContent;
